module.exports = __webpack_public_path__ + "img/feature1.8dc10287.png";